import { render, staticRenderFns } from "./ProductLightbule530.vue?vue&type=template&id=2520bc7e&scoped=true"
import script from "./ProductLightbule530.vue?vue&type=script&lang=js"
export * from "./ProductLightbule530.vue?vue&type=script&lang=js"
import style0 from "./ProductLightbule530.vue?vue&type=style&index=0&id=2520bc7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520bc7e",
  null
  
)

export default component.exports